import currencyFormatter from 'currency-formatter';

const getFormattedCurrency = (value, type) => {
	return (currencyFormatter.format(value, {code: type})).slice(0,-3);
}

export {
	getFormattedCurrency
}